import { render, staticRenderFns } from "./Order_other_main.vue?vue&type=template&id=24389fb9&scoped=true&"
import script from "./Order_other_main.vue?vue&type=script&lang=js&"
export * from "./Order_other_main.vue?vue&type=script&lang=js&"
import style0 from "./Order_other_main.vue?vue&type=style&index=0&id=24389fb9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24389fb9",
  null
  
)

export default component.exports